/**
 * Typed client for /api/notifications/ — types from the OpenAPI schema.
 */
import { authFetch } from "@/auth/fetchClient";
import type { components } from "./schema";

type S = components["schemas"];

export type Notification = S["_NotificationSchema"];
export type NotificationsList = S["_NotificationsListSchema"];

export async function listNotifications(): Promise<NotificationsList> {
  const res = await authFetch("/api/notifications/");
  if (!res.ok) {
    // Don't surface infrastructure errors as red icons in the navbar — degrade
    // silently. The bell shows nothing and the user works as if all-clear.
    return { items: [] };
  }
  return (await res.json()) as NotificationsList;
}
